import ReactDOM from "react-dom";
import React from "react";
import "./index.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
